import React, { FC } from "react";
import { BucketSizeChartCard } from "containers/BucketSizeChartCard";
import { Top5BucketsChartCard } from "containers/Top5BucketsChartCard";

import styles from "./OverviewCharts.module.css";


const OverviewCharts: FC = () => {
  return (
    <div className={styles.chartsContainer}>
      <div className={styles.bigChartItem}>
        <BucketSizeChartCard />
      </div>

      <div className={styles.smallChartItem}>
        <Top5BucketsChartCard />
      </div>
    </div>
  );
};

export default OverviewCharts;
